import { render, staticRenderFns } from "./SelectCreditors.vue?vue&type=template&id=ec3671aa&scoped=true"
import script from "./SelectCreditors.vue?vue&type=script&lang=js"
export * from "./SelectCreditors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3671aa",
  null
  
)

export default component.exports